<template>
    <div class="border-b border-grey-300 overflow-hidden absolute top-0 left-0 w-full z-negative">
        <div class="pb-32 bg-white border-t border-blue-100 pt-44" style="min-height: 550px;">
            <div class="container flex justify-between">
                <div class="w-1/4">
                    <img loading="lazy" :src="node.icon" class="w-40" alt="" />
                </div>

                <div class="w-1/4">
                    <div class="ml-auto" style="width: 250px;">
                        <h2 class="text-4xl text-blue-500 h2">
                            {{ node.title }}
                        </h2>
                        <div
                            v-if="node.text"
                            class="mt-8 text-blue-500 wysiwyg"
                            v-html="node.text"
                        ></div>
                        <a
                            v-if="node.button && node.button.href && node.button.text"
                            :href="node.button.href"
                            :target="node.button.newTab ? '_blank' : ''"
                            class="mt-10 btn btn--full"
                            >{{ node.button.text }}</a
                        >
                    </div>
                </div>

                <div class="relative w-1/4">
                    <!-- Condition is to reset submenus if megamenu is hidden -->
                    <MegamenuList v-if="megaMenuActive" :node="node" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import MegamenuList from './MegamenuList.vue';

export default {
    props: {
        node: {
            type: Object,
            required: true
        },
        megaMenuActive: {
            type: Boolean,
            default: false
        }
    },
    components: { MegamenuList }
};
</script>
